// Market Cap Meter thresholds for percentage of investable universe excluded
export const METRIC_METER_THRESHOLDS = {
  RED: 43,      // Red warning: > 43% excluded
  YELLOW: 35,   // Yellow warning: >= 35% excluded
};

// Legacy meter score thresholds (used when feature flag is disabled)
export const LEGACY_METER_SCORE_THRESHOLDS = {
  RED: 50,      // Red warning: > 50
  YELLOW: 45,   // Yellow warning: > 45
};
